/** `true` als het klembord de tekst aannam. */
export async function copyText(text: string): Promise<boolean> {
    try {
        await navigator.clipboard.writeText(text);

        return true;
    } catch {
        return false;
    }
}

/**
 * Biedt een bestand aan als download. In de kantoorpreview komt de PDF met de
 * sessie binnen, dus een gewone link naar de API werkt daar niet.
 */
export function offerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = filename;
    link.rel = 'noopener';
    document.body.append(link);
    link.click();
    link.remove();

    /* Even laten staan: sommige browsers lezen het bestand pas na de klik. */
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
